import React from 'react';
import { Container, Grid, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  Inventory as ProductsIcon,
  Business as SuppliersIcon,
  People as ClientsIcon,
  RequestQuote as QuoteIcon,
} from '@mui/icons-material';
import { ModuleCard } from '../../../shared/components/ui';

interface ModuleData {
  title: string;
  description: string;
  icon: React.ReactElement;
  route: string;
}

const modules: ModuleData[] = [
  {
    title: 'Productos',
    description: 'Gestión completa del catálogo de productos y servicios',
    icon: <ProductsIcon />,
    route: '/catalogo',
  },
  {
    title: 'Proveedores',
    description: 'Administración de proveedores y relaciones comerciales',
    icon: <SuppliersIcon />,
    route: '/proveedores/admin',
  },
  {
    title: 'Clientes',
    description: 'Gestión de clientes y base de datos comercial',
    icon: <ClientsIcon />,
    route: '/clientes',
  },
  {
    title: 'Cotización',
    description: 'Sistema de cotizaciones y presupuestos',
    icon: <QuoteIcon />,
    route: '/cotizaciones',
  },
];

export const HomePage: React.FC = () => {
  const navigate = useNavigate();

  const handleModuleClick = (route: string) => {
    navigate(route);
  };

  return (
    <Container maxWidth="lg" sx={{ paddingY: 4 }}>
      <Box sx={{ marginBottom: 4, textAlign: 'center' }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 700,
            color: '#a0588e',
            marginBottom: 2,
          }}
        >
          CV Printing
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontFamily: 'Poppins, sans-serif',
            color: '#666666',
            fontWeight: 400,
          }}
        >
          Sistema de Gestión Comercial
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {modules.map((module) => (
          <Grid size={{ xs: 12, sm: 6, md: 3 }} key={module.title}>
            <ModuleCard
              title={module.title}
              description={module.description}
              icon={module.icon}
              onClick={() => handleModuleClick(module.route)}
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}; 